// extracted by mini-css-extract-plugin
export var authorAndDate = "index-module--authorAndDate--lxMfW";
export var line = "index-module--line--DNhaI";